function CreateUserRole() {
  return (
    <div>
      <div className="flex-nowrap flex-center justify-content-between">
        <div>
          <h5>Create User Role</h5>
        </div>
      </div>
      <div className="flex-nowrap  justify-content-between mt-4">
        <div className="list-input-wrapper">
          <label className="input">
            <input type="text" placeholder="Role Name" />
          </label>
        </div>
        <div>
          <button className="btn-primary btn--sm">Save</button>
        </div>
      </div>
      <div className="card border rounded-border-sm  mt-3">
        <div className="flex-nowrap p-2 bg-light">
          <div className="fc">
            <p className="f-500">Campaign</p>
          </div>
        </div>
        <div className="flex-nowrap p-2">
          <div className="fc">
            <p className="f-500">Invoice</p>
          </div>
          <div className="fc-auto">
            <div className="flex-center gap-lg">
              <label className="flex-center gap-sm">
                <input type="radio" />
                Read
              </label>
              <label className="flex-center gap-sm">
                <input type="radio" />
                Read & Write
              </label>
            </div>
          </div>
        </div>
        <div className="flex-nowrap p-2">
          <div className="fc">
            <p className="f-500">Batch Upload</p>
          </div>
          <div className="fc-auto">
            <div className="flex-center gap-lg">
              <label className="flex-center gap-sm">
                <input type="radio" />
                Read
              </label>
              <label className="flex-center gap-sm">
                <input type="radio" />
                Read & Write
              </label>
            </div>
          </div>
        </div>
      </div>
      <div className="card border rounded-border-sm  mt-3">
        <div className="flex-nowrap p-2 bg-light">
          <div className="fc">
            <p className="f-500">Templates</p>
          </div>
        </div>
        <div className="flex-nowrap p-2">
          <div className="fc">
            <p className="f-500">SMS</p>
          </div>
          <div className="fc-auto">
            <div className="flex-center gap-lg">
              <label className="flex-center gap-sm">
                <input type="radio" />
                Read
              </label>
              <label className="flex-center gap-sm">
                <input type="radio" />
                Read & Write
              </label>
            </div>
          </div>
        </div>
        <div className="flex-nowrap p-2">
          <div className="fc">
            <p className="f-500">Email</p>
          </div>
          <div className="fc-auto">
            <div className="flex-center gap-lg">
              <label className="flex-center gap-sm">
                <input type="radio" />
                Read
              </label>
              <label className="flex-center gap-sm">
                <input type="radio" />
                Read & Write
              </label>
            </div>
          </div>
        </div>
      </div>
      <div className="card border rounded-border-sm  mt-3">
        <div className="flex-nowrap p-2 bg-light">
          <div className="fc">
            <p className="f-500">User</p>
          </div>
        </div>
        <div className="flex-nowrap p-2">
          <div className="fc">
            <p className="f-500">List</p>
          </div>
          <div className="fc-auto">
            <div className="flex-center gap-lg">
              <label className="flex-center gap-sm">
                <input type="radio" />
                Read
              </label>
              <label className="flex-center gap-sm">
                <input type="radio" />
                Read & Write
              </label>
            </div>
          </div>
        </div>
        <div className="flex-nowrap p-2">
          <div className="fc">
            <p className="f-500">Roles</p>
          </div>
          <div className="fc-auto">
            <div className="flex-center gap-lg">
              <label className="flex-center gap-sm">
                <input type="radio" />
                Read
              </label>
              <label className="flex-center gap-sm">
                <input type="radio" />
                Read & Write
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateUserRole;
